import { isIE as isIECommon, silentRequest as silentRequestCommon, b2cPolicies as b2cPoliciesCommon } from "./b2c.config.common";

export const isIE = isIECommon;

const b2cPol : Partial<typeof b2cPoliciesCommon> = {
  tokenRenewalOffsetSeconds: 600,
  authorities: {
    signIn: {
      authority: "https://luminavlinkdev.b2clogin.com/tfp/luminavlinkdev.onmicrosoft.com/B2C_1_SI",
    },
  },
  redirectUri: window.location.origin,
  authorityDomain: "luminavlinkdev.b2clogin.com",
  clientId: "4191dae4-e78d-49e8-9e0d-a5ce086eedcc", //Luminav Pro Dev - Client App
}
export const b2cPolicies = { ...b2cPoliciesCommon, ...b2cPol };
export const API_ACCESS_SCOPE = "https://luminavlinkdev.onmicrosoft.com/webapi/read";

export const silentRequest = silentRequestCommon;

export const loginRequest = {
  scopes: ['openid', 'profile', API_ACCESS_SCOPE]
}


